import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonCostFormComponent } from './common-costing-form.component';

const routes: Routes = [{ path: '', component: CommonCostFormComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class CommonCostFormRoutingModule { }